import React, { useEffect, useState } from "react";
import { Alert, Form, InputNumber, Modal, Radio, Space } from "antd";
import { useTranslation } from "react-i18next";
import { SHELF_LABEL_FORMATS } from "constants/PickingConstant";
import { labelsForSheet } from "functions/shelfLabels";

const HELP = {
  card: "pick_route.print_labels_card_help",
  product: "pick_route.print_labels_product_help",
  magnetCard: "pick_route.print_labels_magnet_help",
  magnetProduct: "pick_route.print_labels_magnet_help",
};

/**
 * Before printing vak labels: how many, in which format, and - for the sticker sheets - from
 * which position on the first sheet: polyester sheets are expensive, a half-used one should be
 * usable. Cards for the card holders are cut from plain paper and always start at the top: a vak
 * card per vak, a product card per vak something lies in.
 */
const LabelPrintModal = ({ open, labels, skipped, format: initialFormat = "card", onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [format, setFormat] = useState(initialFormat);
  const [startSlot, setStartSlot] = useState(1);
  const sheet = SHELF_LABEL_FORMATS[format];
  const perPage = sheet.columns * sheet.rows;
  const sticker = format === "sticker";
  const count = labelsForSheet(labels, sheet).length;
  const empty = (labels || []).length - count;

  useEffect(() => {
    if (!open) return;
    setStartSlot(1);
    setFormat(initialFormat);
  }, [open, initialFormat]);

  const first = sticker ? startSlot : 1;
  const sheets = Math.ceil((count + first - 1) / perPage);

  return (
    <Modal
      open={open}
      title={t("pick_route.print_labels_title")}
      okText={t("pick_route.print_labels_confirm", { count })}
      cancelText={t("cancel")}
      okButtonProps={{ disabled: count === 0 }}
      onOk={() => onConfirm({ startSlot: first, format })}
      onCancel={onCancel}
    >
      <Form layout="vertical">
        <Form.Item label={t("pick_route.print_labels_format")}>
          <Radio.Group value={format} onChange={(event) => setFormat(event.target.value)}>
            <Space direction="vertical">
              <Radio value="card">{t("pick_route.print_labels_format_card")}</Radio>
              <Radio value="product">{t("pick_route.print_labels_format_product")}</Radio>
              <Radio value="magnetCard">{t("pick_route.print_labels_format_magnet_card")}</Radio>
              <Radio value="magnetProduct">{t("pick_route.print_labels_format_magnet_product")}</Radio>
              <Radio value="sticker">{t("pick_route.print_labels_format_sticker")}</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        <p style={{ color: "#6b6b6b" }}>{sticker ? t("pick_route.print_labels_help", { sheet: sheet.name }) : t(HELP[format])}</p>
        {skipped > 0 && <Alert type="warning" showIcon className="mb-3" message={t("pick_route.print_labels_skipped", { count: skipped })} />}
        {empty > 0 && <Alert type="info" showIcon className="mb-3" message={t("pick_route.print_labels_empty", { count: empty })} />}
        {sticker && (
          <Form.Item label={t("pick_route.print_labels_start")} help={t("pick_route.print_labels_start_help", { perPage })}>
            <InputNumber min={1} max={perPage} value={startSlot} onChange={(value) => setStartSlot(value || 1)} />
          </Form.Item>
        )}
      </Form>
      <p>{t("pick_route.print_labels_sheets", { count: sheets })}</p>
    </Modal>
  );
};

export default LabelPrintModal;
